import { render } from "./StudentPurchaseLimit.vue?vue&type=template&id=1e0b2db3&scoped=true"
import script from "./StudentPurchaseLimit.vue?vue&type=script&lang=js"
export * from "./StudentPurchaseLimit.vue?vue&type=script&lang=js"

import "./StudentPurchaseLimit.vue?vue&type=style&index=0&id=1e0b2db3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e0b2db3"]])

export default __exports__